import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
// import { videosData } from "../data/youtube";
import axios from "axios";
import { API_URL } from "../utils/url";
const VideoPage = () => {
  const [activeVideo, setActiveVideo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [videosData, setVideosData] = useState([]);

  const fetchYoutube = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${API_URL}/api/youtube/get-active-youtube`,
      );
      setVideosData(data || []);
    } catch (error) {
      console.log(error);
      // toast.error("Unable to fetch videos.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchYoutube();
  }, []);
  return (
    <div style={styles.pageBackground}>
      {/* Decorative Neon Blobs for Unique Visual Appeal */}
      <div style={styles.neonBlob1}></div>
      <div style={styles.neonBlob2}></div>

      <Container className="py-5" style={{ position: "relative", zIndex: 2 }}>
        {/* Animated Header */}
        <motion.header
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-5"
        >
          <h1 style={styles.mainTitle}>
            Vishnuji <span style={styles.gradientText}>Maharaj</span>
          </h1>
          <p style={styles.subtitle}>
            Immerse yourself in divine pravachans & soul-stirring bhajans
          </p>
        </motion.header>

        {/* Dynamic Video Grid using Bootstrap layout */}
        <Row className="g-4">
          {videosData.map((video, index) => (
            <Col key={video.id} xs={12} md={6} lg={4}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -10, scale: 1.02 }}
                style={styles.card}
                onClick={() => setActiveVideo(video)}
              >
                {/* Image Wrapper with vibrant gradient border reflection */}
                <div style={styles.thumbnailWrapper}>
                  <img
                    src={
                      video?.blogImage?.url ||
                      `https://img.youtube.com/vi/${video.videoUrl}/mqdefault.jpg`
                    }
                    alt={video.title}
                    style={styles.thumbnailImg}
                    onError={(e) => {
                      e.target.src = `https://img.youtube.com/vi/${video.videoUrl}/hqdefault.jpg`;
                    }}
                  />
                  {/* Category Tag */}
                  {/* <span
                    style={{
                      ...styles.categoryBadge,
                      background: video.gradient,
                    }}
                  >
                    {video.category}
                  </span> */}

                  {/* Animated Play Button Overlay */}
                  <motion.div
                    style={styles.playOverlay}
                    whileHover={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
                  >
                    <motion.div
                      style={styles.playButtonCircle}
                      whileHover={{ scale: 1.15 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="#fff"
                      >
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </motion.div>
                  </motion.div>
                </div>

                {/* Info Area */}
                <div style={styles.videoInfo}>
                  <h3 style={styles.videoTitle}>{video.title}</h3>
                  {/* <p style={styles.videoDesc}>{video.description}</p> */}
                </div>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* --- ANIMATED PREMIUM MODAL (POPUP) --- */}
      <AnimatePresence>
        {activeVideo && (
          <Modal
            show={!!activeVideo}
            onHide={() => setActiveVideo(null)}
            centered
            size="lg"
            dialogClassName="premium-modal"
            contentClassName="custom-modal-content"
            backdrop="static" // Prevents accidental closing while watching
            keyboard={true}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
              style={styles.modalContentStyle}
            >
              {/* Close Header Button */}
              <button
                style={styles.closeBtn}
                onClick={() => setActiveVideo(null)}
              >
                &times;
              </button>

              {/* Aspect Ratio Controlled Video Wrapper */}
              <div style={styles.popupVideoWrapper}>
                <iframe
                  src={`https://www.youtube.com/embed/${activeVideo.videoUrl}?autoplay=1&rel=0&modestbranding=1&controls=1&showinfo=1`}
                  title={activeVideo.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={styles.popupIframe}
                ></iframe>
              </div>

              {/* Info section below player */}
              <div style={styles.popupInfo}>
                <span
                  style={{
                    ...styles.categoryBadge,
                    background: activeVideo.gradient,
                    position: "static",
                  }}
                >
                  {activeVideo.category}
                </span>
                <h2 style={styles.popupTitle} className="mt-2">
                  {activeVideo.title}
                </h2>
                <p style={styles.popupDesc}>{activeVideo.description}</p>
              </div>
            </motion.div>
          </Modal>
        )}
      </AnimatePresence>

      {/* CSS Injection for Dynamic Bootstrap overrides */}
      <style>{`
        .premium-modal { max-width: 950px !important; }
        .custom-modal-content { 
          background: transparent !important; 
          border: none !important; 
        }
        .modal-backdrop {
          background-color: #05050c !important;
          opacity: 0.85 !important;
          backdrop-filter: blur(15px) !important;
        }
      `}</style>
    </div>
  );
};

// --- STYLES: COLORFUL NEON & PREMIUM GLASSMORPHISM ---
const styles = {
  pageBackground: {
    // Isse pure page par aapka texture apply ho jayega aur background color upar se blend hoga
    backgroundColor: "#f5f5f5",
    backgroundImage:
      "url('https://www.transparenttextures.com/patterns/cream-pixels.png')",
    backgroundRepeat: "repeat",
    minHeight: "100vh",
    // color: "#fff",
    overflow: "hidden",
    position: "relative",
  },
  neonBlob1: {
    position: "absolute",
    width: "400px",
    height: "400px",
    background: "linear-gradient(130deg, #a855f7, #6366f1)",
    top: "-100px",
    left: "-100px",
    filter: "blur(150px)",
    opacity: 0.25,
    pointerEvents: "none",
  },
  neonBlob2: {
    position: "absolute",
    width: "500px",
    height: "500px",
    background: "linear-gradient(130deg, #06b6d4, #ec4899)",
    bottom: "-100px",
    right: "-100px",
    filter: "blur(180px)",
    opacity: 0.2,
    pointerEvents: "none",
  },
  mainTitle: {
    fontSize: "3.5rem",
    fontWeight: "800",
    letterSpacing: "-1px",
  },
  gradientText: {
    background: "linear-gradient(90deg, #06b6d4, #a855f7, #f43f5e)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  subtitle: {
    color: "#94a3b8",
    fontSize: "1.2rem",
    fontWeight: "400",
  },
  card: {
    // background: "rgba(255, 255, 255, 0.03)",
    backdropFilter: "blur(10px)",
    borderRadius: "24px",
    overflow: "hidden",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
    cursor: "pointer",
    height: "100%",
  },
  thumbnailWrapper: {
    position: "relative",
    paddingBottom: "56.25%",
    height: 0,
    overflow: "hidden",
  },
  thumbnailImg: {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    top: 0,
    left: 0,
  },
  categoryBadge: {
    position: "absolute",
    top: "15px",
    left: "15px",
    padding: "5px 14px",
    borderRadius: "30px",
    fontSize: "0.75rem",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "1px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  },
  playOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  playButtonCircle: {
    width: "65px",
    height: "65px",
    // background: "rgba(255, 255, 255, 0.15)",
    // backdropFilter: "blur(8px)",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid rgba(255,255,255,0.4)",
    boxShadow: "0 0 25px rgba(255,255,255,0.2)",
  },
  videoInfo: {
    padding: "25px",
  },
  videoTitle: {
    fontSize: "1.25rem",
    fontWeight: "600",
    lineHeight: "1.4",
    marginBottom: "10px",
    color: "#18135c",
  },
  videoDesc: {
    color: "#94a3b8",
    fontSize: "0.9rem",
    margin: 0,
    lineHeight: "1.6",
  },

  // --- MODAL INTERNAL STYLING ---
  modalContentStyle: {
    background: "rgba(15, 17, 34, 0.85)",
    backdropFilter: "blur(25px)",
    borderRadius: "28px",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    overflow: "hidden",
    boxShadow: "0 30px 60px rgba(0,0,0,0.6)",
    position: "relative",
  },
  closeBtn: {
    position: "absolute",
    top: "2px",
    right: "-2px",
    backgroundColor: "rgba(255,255,255,0.1)",
    border: "1px solid rgba(255,255,255,0.2)",
    color: "#fff",
    fontSize: "28px",
    cursor: "pointer",
    zIndex: 10,
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s",
  },
  popupVideoWrapper: {
    position: "relative",
    paddingBottom: "56.25%",
    height: 0,
    background: "#000",
  },
  popupIframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  popupInfo: {
    padding: "30px",
  },
  popupTitle: {
    fontSize: "1.75rem",
    fontWeight: "700",
  },
  popupDesc: {
    color: "#cbd5e1",
    fontSize: "1rem",
    lineHeight: "1.6",
  },
};

export default VideoPage;
